var sortFolders = function (folders) {
    return folders === null || folders === void 0 ? void 0 : folders.sort(function (a, b) {
        if ((a === null || a === void 0 ? void 0 : a.name) < (b === null || b === void 0 ? void 0 : b.name))
            return -1;
        if ((a === null || a === void 0 ? void 0 : a.name) > (b === null || b === void 0 ? void 0 : b.name))
            return 1;
        return 0;
    });
};
export { sortFolders };
//# sourceMappingURL=helper.js.map